export const SET_TRATAMIENTOS = "SET_TRATAMIENTOS";
export const UPDATE_TRATAMIENTO_IN_ARRAY = "UPDATE_TRATAMIENTO_IN_ARRAY";
export const ADD_TRATAMIENTO_IN_ARRAY = "ADD_TRATAMIENTO_IN_ARRAY";
export const REMOVE_TRATAMIENTO_IN_ARRAY = "REMOVE_TRATAMIENTO_IN_ARRAY";
